/* ==========================================================================
   INTRO SECTION
   ========================================================================== */

const introSectionScroll = (wrapper: HTMLElement) => {
  const sectionsWrapper = wrapper.querySelector<HTMLDivElement>(
    ".intro-section__sections"
  );
  const sections = wrapper.querySelectorAll<HTMLDivElement>(
    ".intro-section__section"
  );
  const scrollBar = wrapper.querySelector<HTMLDivElement>(
    ".intro-section__scrollbar"
  );
  const scrollBarBar = wrapper.querySelector<HTMLDivElement>(
    ".intro-section__scrollbar__bar"
  );
  const media = wrapper.querySelector<HTMLElement>(".intro-section__media");

  if (sectionsWrapper && scrollBar) {
    const wrapperPosition = wrapper.getBoundingClientRect();
    const wrapperScrollTop = wrapperPosition.top;

    const screenPosition = sectionsWrapper.getBoundingClientRect();
    const elScrollTop = screenPosition.top;

    const scaleDuration = media ? window.innerHeight * 2 : window.innerHeight;

    if (media) {
      const scale =
        wrapperScrollTop < 0
          ? wrapperScrollTop * -1 >= scaleDuration
            ? 1
            : Math.abs(wrapperScrollTop / scaleDuration)
          : 0;

      media.style.setProperty("--scale", scale.toString());

      if (scale >= 0.025) {
        media.classList.add("opacity-100");
        media.classList.remove("opacity-0");
      } else {
        media.classList.add("opacity-0");
        media.classList.remove("opacity-100");
      }

      if (
        wrapperScrollTop < 0 &&
        wrapperScrollTop > wrapper.clientHeight * -1
      ) {
        // We haven't scrolled past the ssection yet
      } else {
        media.classList.add("opacity-0");
        media.classList.remove("opacity-100");
      }
    }

    if (elScrollTop < 0 && elScrollTop > sectionsWrapper.clientHeight * -1) {
      // Show the scrollbar and sections
      const currSection =
        Math.ceil(Math.abs(elScrollTop) / window.innerHeight) - 1;

      scrollBar.classList.add("opacity-100");
      scrollBar.classList.remove("opacity-0");
      if (scrollBarBar) {
        const scrollBarBarHeight =
          Math.abs(
            (elScrollTop - window.innerHeight) /
              (sectionsWrapper.clientHeight - window.innerHeight)
          ) * 100;
        scrollBarBar.style.height =
          (scrollBarBarHeight >= 100 ? 100 : scrollBarBarHeight) + "%";
        if (scrollBarBarHeight >= 1) {
          scrollBar.classList.add("opacity-100");
          scrollBar.classList.remove("opacity-0");
        } else {
          scrollBar.classList.remove("opacity-100");
          scrollBar.classList.add("opacity-0");
        }
      }

      [...sectionsWrapper.children].forEach((section, i) => {
        if (section.classList.contains("intro-section__section")) {
          if (
            (i == currSection ||
              (i <= currSection && i == sectionsWrapper.children.length - 1)) &&
            scrollBar.classList.contains("opacity-100")
          ) {
            section.classList.add("opacity-100");
            section.classList.remove("opacity-0");
            section.classList.remove("pointer-events-none");
          } else {
            section.classList.add("opacity-0");
            section.classList.add("pointer-events-none");
            section.classList.remove("opacity-100");
          }
        }
      });

      const lastSection: Element | null = [...sections][sections.length - 1];
      if (currSection >= sections.length && lastSection) {
        lastSection.classList.add("opacity-100");
        lastSection.classList.remove("opacity-0");
        lastSection.classList.remove("pointer-events-none");
      }
    } else {
      // Hide the scrollbar and sections
      scrollBar.classList.add("opacity-0");
      scrollBar.classList.remove("opacity-100");
      for (const section of sections) {
        section.classList.add("opacity-0");
        section.classList.add("pointer-events-none");
        section.classList.remove("opacity-100");
      }
    }
  }
};

window.addEventListener("load", function () {
  for (const wrapper of document.querySelectorAll<HTMLElement>(
    ".intro-section"
  )) {
    introSectionScroll(wrapper);
  }
});

window.addEventListener("resize", function () {
  for (const wrapper of document.querySelectorAll<HTMLElement>(
    ".intro-section"
  )) {
    introSectionScroll(wrapper);
  }
});

window.addEventListener("scroll", function () {
  for (const wrapper of document.querySelectorAll<HTMLElement>(
    ".intro-section"
  )) {
    introSectionScroll(wrapper);
  }
});
